import React from "react";
import { Video, ExternalLink, Copy, X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { toast } from "sonner";

// Generates a unique, free Jitsi Meet room URL (no API key required).
export const genMeetingUrl = () =>
  `https://meet.jit.si/RFL-${Math.random().toString(36).slice(2, 9)}-${Date.now().toString(36)}`;

export default function VideoMeetingModal({ open, onOpenChange, url, title, name }) {
  const copy = () => {
    navigator.clipboard?.writeText(url);
    toast.success("Meeting link copied");
  };

  // Pre-fill display name + skip prejoin for a smoother in-app experience.
  const embedUrl = url
    ? `${url}#userInfo.displayName=%22${encodeURIComponent(name || "RFL Guest")}%22&config.prejoinPageEnabled=false`
    : "";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl p-0 overflow-hidden">
        <DialogHeader className="px-5 py-3 border-b border-gray-100">
          <DialogTitle className="font-serif text-navy flex items-center gap-2">
            <Video className="h-5 w-5 text-gold-dark" /> {title || "Video Meeting"}
          </DialogTitle>
        </DialogHeader>

        {url && (
          <>
            <div className="bg-navy-deep">
              <iframe
                title="Video meeting"
                src={embedUrl}
                allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"
                className="w-full h-[60vh] border-0"
              />
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-2 px-5 py-3 border-t border-gray-100">
              <div className="flex-1 text-xs text-gray-500 truncate w-full">{url}</div>
              <div className="flex gap-2">
                <Button variant="outline" onClick={copy} className="h-9">
                  <Copy className="h-4 w-4 mr-1.5" /> Copy link
                </Button>
                <a href={url} target="_blank" rel="noreferrer">
                  <Button className="h-9 bg-navy hover:bg-navy-light text-white">
                    <ExternalLink className="h-4 w-4 mr-1.5" /> Open in new tab
                  </Button>
                </a>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
